import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Menus from './views/Menus.vue';
import Settings from './views/Settings.vue';
import DeliverySettings from './views/DeliverySettings.vue';
import ConfirmApplication from './views/ConfirmApplication.vue';
import Workers from './views/Workers.vue';
import POSIntegrations from './views/POSIntegrations.vue';
import PosterRedirect from './views/PosterRedirect.vue';
import Stats from './views/Stats.vue';
import Discounts from './views/Discounts.vue';
import Billing from './views/Billing.vue';
import PreorderSettings from './views/PreorderSettings.vue';
import GeneralSettings from './views/GeneralSettings.vue';
import InsideSettings from './views/InsideSettings.vue';
import ReserveSettings from './views/ReserveSettings.vue';
import NewReserveSettings from './views/NewReserveSettings.vue';
import LoyaltySettings from './views/LoyaltySettings.vue';
import InsideLiteSettings from './views/InsideLiteSettings.vue';
import ConfirmEmailChange from './views/ConfirmEmailChange.vue';
import Subscriptions from './views/Subscriptions.vue';
import Marketplace from './views/Marketplace.vue';
import Reviews from './views/Reviews.vue';
import DepositForm from './views/DepositForm.vue';
import Marketing from './views/Marketing.vue';
import Table from './views/Table.vue';
import Halls from './views/Halls.vue';
import Notifications from './views/Notifications.vue';
import Changelog from './views/Changelog.vue';
import ClientsBase from './views/ClientsBase.vue';
import CorporateCafes from './views/CorporateCafes.vue';
import CorporateUsers from './views/CorporateUsers.vue';
import AccountSettings from './views/AccountSettings.vue';
import MarketplaceList from './views/MarketplaceList.vue';
import ChangesHistory from './views/ChangesHistory.vue';
import ConfirmEmployee from './views/ConfirmEmployee.vue';
import CorporateStats from './views/CorporateStats.vue';
import ExternalIntegration from './views/IntegrationPage.vue';
import IntegrationsMarket from './views/IntegrationsMarket.vue';
import WorkerProfile from './views/WorkerProfile.vue';
import OnlinePayment from './views/OnlinePayment.vue';
import HotelsSettings from './views/HotelsSettings.vue';
import ChainSettings from './views/ChainSettings.vue';
import SystemsStore from './views/SystemsStore.vue';
import SubscriptionHistory from './views/SubscriptionHistory.vue';
import StickersBag from './views/StickersBag.vue';
import StickersGallery from './views/StickersGallery.vue';
import ShipmentArchive from './views/ShipmentsArchive.vue';
import PromocodeInfoPage from './components/marketing/PromocodeInfoPage.vue';
import StatsOrders from './views/StatsOrders.vue';
import StatsGuests from './views/StatsGuests.vue';
import StatsFinances from './views/StatsFinances.vue';
import StatsTraffic from './views/StatsTraffic.vue';
import StatsTables from './views/StatsTables.vue';
import StatsAverageCheck from './views/StatsAverageCheck.vue';
import ClientProfile from './views/ClientProfile.vue';
import NewStructureTest from './views/NewStructureTest.vue';
import Quickstart from './views/Quickstart.vue';
import OrdersPanel from './views/OrdersPanel.vue';
import PreviewSettings from './views/PreviewSettings.vue';
import MiscIntegrations from './views/MiscIntegrations.vue';
import DeliveryPartner from './views/DeliveryPartner.vue';
import ClientOrdersHistory from './views/ClientOrdersHistory.vue';
import ConfirmRegister from './views/ConfirmRegister.vue';
import PasswordRecovery from './views/PasswordRecovery.vue';
import Taxes from './views/Taxes.vue';
import ClientApp from './views/ClientApp.vue';
import Balance from './views/Balance.vue';
import BalanceTable from './views/BalanceTable.vue';
import SmsSettings from './views/SmsSettings.vue';
import NomenculaturePackaging from './views/NomenculaturePackaging.vue';
import SmsHistory from './views/SmsHistory.vue';
import Checklists from './views/Checklists.vue';
import ChecklistReports from './views/ChecklistReports.vue';
import ChecklistEditor from './views/ChecklistEditor.vue';
import ChecklistReport from './views/ChecklistReport.vue';
import WorkingSchedule from './views/WorkingSchedule.vue';
import Superbilling from './views/Superbilling.vue';
import TipsSettings from './views/TipsSettings.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/stats/orders',
    },
    {
      path: '/general',
      name: 'general',
      component: GeneralSettings,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/cafe',
      // name: "cafe",
      // component: Dashboard,
      redirect: '/',
    },
    {
      path: '/stats',
      name: 'stats',
      component: Stats,
    },
    {
      path: '/stats/orders',
      name: 'stats_orders',
      component: StatsOrders,
    },
    {
      path: '/stats/guests',
      name: 'stats_guests',
      component: StatsGuests,
    },
    {
      path: '/stats/finances',
      name: 'stats_finances',
      component: StatsFinances,
    },
    {
      path: '/stats/tables',
      name: 'stats_tables',
      component: StatsTables,
    },
    {
      path: '/stats/traffic',
      name: 'stats_traffic',
      component: StatsTraffic,
    },
    {
      path: '/stats/average',
      name: 'stats_average',
      component: StatsAverageCheck,
    },
    {
      path: '/menus',
      name: 'menus',
      meta: {
        reuse: false,
      },
      component: Menus,
    },
    {
      path: '/menus/:id',
      name: 'menu',
      meta: {
        reuse: false,
      },
      component: Menus,
    },
    {
      path: '/workers',
      name: 'workers',
      component: Workers,
    },
    {
      path: '/discounts',
      name: 'discounts',
      component: Discounts,
    },
    {
      path: '/billing',
      name: 'billing',
      component: Billing,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/qrcodes',
      name: 'qrcodes',
      component: Dashboard,
    },
    {
      path: '/reserve',
      name: 'reserve',
      component: ReserveSettings,
    },
    {
      path: '/reserve_new',
      name: 'reserve_new',
      component: NewReserveSettings,
    },
    {
      path: '/delivery',
      name: 'delivery',
      component: DeliverySettings,
    },
    {
      path: '/preorder',
      name: 'preorder',
      component: PreorderSettings,
    },
    {
      path: '/inside',
      name: 'inside',
      component: InsideSettings,
    },
    {
      path: '/hotels',
      name: 'hotels',
      component: HotelsSettings,
    },
    {
      path: '/inside_lite',
      name: 'inside_lite',
      component: InsideLiteSettings,
    },
    {
      path: '/loyalty',
      name: 'loyalty',
      component: LoyaltySettings,
    },
    {
      path: '/marketplace',
      name: 'marketplace',
      component: Marketplace,
    },
    {
      path: '/confirm_registration/:key',
      name: 'confirm',
      component: ConfirmApplication,
    },
    {
      path: '/poster_redirect',
      name: 'poster_redirect',
      component: PosterRedirect,
    },
    {
      path: '/pos_integrations',
      name: 'pos_integrations',
      component: POSIntegrations,
    },
    {
      path: '/pos_integrations/:id',
      name: 'pos_integrations_specific',
      meta: {
        reuse: false,
      },
      component: POSIntegrations,
    },
    {
      path: '/integrations',
      name: 'integrations',
      component: IntegrationsMarket,
    },
    {
      path: '/integrations/:id',
      name: 'integration',
      meta: {
        reuse: false,
      },
      component: ExternalIntegration,
    },
    {
      path: '/confirm_email_change/:key',
      name: 'confirm_email_change',
      component: ConfirmEmailChange,
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: Reviews,
    },
    {
      path: '/deposit_form/:key',
      name: 'deposit_form',
      component: DepositForm,
    },
    {
      path: '/tools',
      name: 'tools',
      component: Marketing,
    },
    {
      path: '/systems',
      name: 'systems',
      component: SystemsStore,
    },
    {
      path: '/online_payment',
      name: 'online_payment',
      component: OnlinePayment,
    },
    {
      path: '/online_payment/:gateway',
      name: 'online_payment_specific',
      meta: {
        reuse: false,
      },
      component: OnlinePayment,
    },
    {
      path: '/table/:type',
      name: 'table',
      component: Table,
    },
    {
      path: '/halls',
      name: 'halls',
      component: Halls,
    },
    {
      path: '/rooms',
      name: 'rooms',
      component: Halls,
    },
    {
      path: '/preview',
      name: 'preview',
      component: PreviewSettings,
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
    },
    {
      path: '/changelog',
      name: 'changelog',
      component: Changelog,
    },
    {
      path: '/clients_base',
      name: 'clients_base',
      component: ClientsBase,
    },
    {
      path: '/clients_base/:id/history',
      name: 'client_orders_history',
      component: ClientOrdersHistory,
    },
    {
      path: '/corporate_cafes',
      name: 'corporate_cafes',
      component: CorporateCafes,
    },
    {
      path: '/chain/:id',
      name: 'chain_cafes',
      component: CorporateCafes,
    },
    {
      path: '/chain_settings/:chain_id',
      name: 'chain_settings',
      component: ChainSettings,
    },
    {
      path: '/corporate_users',
      name: 'corporate_users',
      component: CorporateUsers,
    },
    {
      path: '/account_settings',
      name: 'account_settings',
      component: AccountSettings,
    },
    {
      path: '/marketplace_list',
      name: 'marketplace_list',
      component: MarketplaceList,
    },
    {
      path: '/changes_history',
      name: 'changes_history',
      component: ChangesHistory,
    },
    {
      path: '/confirm_employee/:id',
      name: 'confirm_employee',
      component: ConfirmEmployee,
    },
    {
      path: '/corporate_stats',
      name: 'corporate_stats',
      component: CorporateStats,
    },
    {
      path: '/workers/:id',
      name: 'worker_profile',
      component: WorkerProfile,
    },
    {
      path: '/store',
      name: 'systems_store',
      component: SystemsStore,
    },
    {
      path: '/subscription_history',
      name: 'subscription_history',
      component: SubscriptionHistory,
    },
    {
      path: '/stickers_gallery',
      name: 'stickers_gallery',
      component: StickersGallery,
    },
    {
      path: '/stickers_bag',
      name: 'stickers_gallery',
      component: StickersBag,
    },
    {
      path: '/promocodes/:id',
      name: 'promocodes_info',
      meta: {
        reuse: false,
      },
      component: PromocodeInfoPage,
    },
    {
      path: '/shipments_archive',
      name: 'shipments_archive',
      component: ShipmentArchive,
    },
    {
      path: '/clients_base/:id',
      name: 'client_profile',
      meta: {
        reuse: false,
      },
      component: ClientProfile,
    },
    {
      path: '/newstructure',
      name: 'new_structr',
      component: NewStructureTest,
    },
    {
      path: '/quickstart',
      name: 'quickstart',
      component: Quickstart,
    },
    {
      path: '/orders_panel',
      name: 'orders_panel',
      component: OrdersPanel,
    },
    {
      path: '/misc_integrations/:id',
      name: 'misc_integrations',
      component: MiscIntegrations,
    },
    {
      path: '/delivery_partner',
      name: 'delivery_partner',
      component: DeliveryPartner,
    },
    {
      path: '/confirm_register/:id',
      name: 'confirm_register',
      component: ConfirmRegister,
    },
    {
      path: '/password_recovery',
      name: 'password_recovery',
      component: PasswordRecovery,
    },
    {
      path: '/password_recovery/:id',
      name: 'password_recovery_confirm',
      component: PasswordRecovery,
    },
    {
      path: '/taxes',
      name: 'taxes',
      component: Taxes,
    },
    {
      path: '/client_app',
      name: 'client_app',
      component: ClientApp,
    },
    {
      path: '/balance',
      name: 'balance',
      component: Balance,
    },
    {
      path: '/balance/table',
      name: 'balance_table',
      component: BalanceTable,
    },
    {
      path: '/sms_settings',
      name: 'sms_settings',
      component: SmsSettings,
    },
    {
      path: '/sms_history',
      name: 'sms_history',
      component: SmsHistory,
    },
    {
      path: '/nomenculature/packaging',
      name: 'nomenculature_packaging',
      component: NomenculaturePackaging,
    },
    {
      path: '/checklists/templates',
      name: 'checklists',
      component: Checklists,
    },
    {
      path: '/checklists/reports',
      name: 'checklists_reports',
      component: ChecklistReports,
    },
    {
      path: '/checklists/templates/:id',
      name: 'checklist_editor',
      component: ChecklistEditor,
    },
    {
      path: '/checklists/reports/:id',
      name: 'checklist_report',
      component: ChecklistReport,
    },
    {
      path: '/working_schedule',
      name: 'working_schedule',
      component: WorkingSchedule,
    },
    {
      path: '/superbilling',
      name: 'superbilling',
      component: Superbilling,
    },
    {
      path: '/tips_settings',
      name: 'tips_settings',
      component: TipsSettings,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
